<template>
  <div class="login" v-loading="loading">
    <div id="information-box" ref="information">
      <el-row>
        <el-col :span="12">
          <img
            src="../assets/image/login/illustration.png"
            alt
            class="ill-img"
          />
        </el-col>
        <el-col :span="12">
          <div class="form-box">
            <img
              style="width: 64%; margin: 0 auto 10px; display: block"
              src="icon/yxlogo.png"
              alt
            />
            <!-- <img class="tit1" src="../assets/image/login/tit1.png" alt />
						<img class="tit2" src="../assets/image/login/tit2.png" alt />-->
            <el-form ref="form" status-icon :model="form" :rules="rules">
              <el-form-item prop="userCode">
                <el-input
                  @keyup.enter.native="login"
                  placeholder="账户"
                  v-model="form.userCode"
                  prefix-icon="el-icon-user"
                ></el-input>
              </el-form-item>
              <el-form-item prop="userPwd">
                <el-input
                  @keyup.enter.native="login"
                  placeholder="密码"
                  type="password"
                  show-password
                  v-model="form.userPwd"
                  prefix-icon="el-icon-lock"
                ></el-input>
              </el-form-item>
              <el-form-item prop="verCode" class="validate-container">
                <!-- :maxlength="4" -->
                <el-input
                  v-model="form.verCode"
                  style="width: 190px"
                  placeholder="验证码"
                  @keyup.enter.native="login"
                />
                <img
                  :src="validateImg"
                  class="validateImg"
                  @click="getVerCode"
                />
                <!-- <el-button
                    @click="getVerCode"
                    class="huan"
                    size="mini"
								>换一换</el-button>-->
              </el-form-item>
              <div class="save-pw clearfix">
                <div class="fl">
                  <el-checkbox v-model="autoLogin">记住密码</el-checkbox>
                </div>
              </div>
              <el-form-item>
                <el-button type="primary" class="loginBtn" @click="login"
                  >登&nbsp;录</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>



<script>
import { postData, postJson } from '@/http/fetch.js'
import { base64decode, timeLocalStorage } from '@/utils/index'
import md5 from 'js-md5'
import qs from 'qs'
import { conf } from '../config'
export default {
  data() {
    return {
      loading: false,
      validateImg: '',
      form: {
        userCode: '',
        userPwd: '',
        verCode: null,
        clientPackage: conf.clientPackage
      },
      rules: {
        userCode: [
          {
            required: true,
            message: '请输入用户名',
            trigger: ['blur', 'change']
          },
          {
            min: 3,
            max: 20,
            message: '长度必须是 3-20 位',
            trigger: ['blur', 'change']
          }
        ],
        userPwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          {
            min: 3,
            max: 20,
            message: '长度必须是 3-20 位',
            trigger: ['blur', 'change']
          }
        ],
        verCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: ['blur']
          },
          {
            min: 4,
            max: 4,
            message: '长度必须是 4 位',
            trigger: ['blur']
          }
        ]
      },
      autoLogin: false,

      //中心区域 大小自适应
      screenWidth: null, //屏幕尺寸
      screenHeight: null //屏幕尺寸
    }
  },
  computed: {
    teaInfoId() {
      return this.$route.query.teaInfoId || ''
    },
    userId() {
      return this.$route.query.userId || ''
    }
  },
  async created() {
    if (this.userId) {
      this.singleSignUserIdOn()
    } else if (this.teaInfoId) {
      this.singleSignOn()
    } else {
      this.signOn()
    }
  },
  mounted() {
    this.screenWidth = document.body.clientWidth
    this.screenHeight = document.body.clientHeight
    window.onresize = () => {
      //屏幕尺寸变化就重新赋值
      return (() => {
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
      })()
    }
  },
  methods: {
    singleSignUserIdOn() {
      localStorage.setItem('standardUserId', this.userId)
      this.$router.push({ name: 'home' })
    },
    //http://localhost:3011/tdev/#/login?teaInfoId=N2I2OTg1MDUtMzQ2ZS00MTQyLTg5MDYtNWViMTRmNGNhOTVl
    //单点登录
    singleSignOn() {
      this.loading = true
      postData('/oauth/ssoLogin', {
        teaInfoId: base64decode(this.teaInfoId)
      })
        .then((resData) => {
          console.log('res', resData)
          localStorage.setItem('standardUserId', resData.userId)
          this.$message({
            message: '登录成功！',
            type: 'success',
            duration: 2000,
            offset: 150
          })
          this.loading = false
          this.$router.push({ name: 'home' })
        })
        .catch((err) => {
          console.log('err', err)
          // this.$message({
          // 	message: err,
          // 	type: "error",
          // 	duration: 2000,
          // 	offset: 150
          // });
        })
    },
    signOn() {
      //本地保存未失效 自动登录
      if (timeLocalStorage.get('newAutoLogin')) {
        let remeObj = timeLocalStorage.get('newAutoLogin')
        this.form.userCode = remeObj.userCode
        this.form.userPwd = window.atob(remeObj.userPwd) //base64
        this.autoLogin = true
        this.$axios.get('/oauth/getVerCode').then((res) => {
          this.form.verCode = res
          this.login()
        })
      } else {
        this.getVerCode()
      }
    },
    getVerCode() {
      this.$axios
        .get('/oauth/getCode', {
          responseType: 'blob'
        })
        .then((res) => {
          this.validateImg = window.URL.createObjectURL(res)
        })
    },
    async login() {
      try {
        await this.$refs.form.validate()
        //两个单独的对象
        let postForm = JSON.parse(JSON.stringify(this.form))
        postForm.userPwd = md5(postForm.userPwd)
        this.loading = true
        this.$axios
          .post('/oauth/loginByTeacher', qs.stringify(postForm))
          .then(({ data, ext, resultCode, msg }) => {
            this.loading = false
            if (resultCode === 200) {
              //自动登录;
              let remeberObj = {
                userCode: this.form.userCode,
                userPwd: window.btoa(this.form.userPwd) //base64加密
              }
              if (this.autoLogin && !timeLocalStorage.get('newAutoLogin')) {
                let date = new Date().getTime() //1000 1s
                timeLocalStorage.set(
                  'newAutoLogin',
                  remeberObj,
                  date + 1000 * 60 * 60 * 24 * 30
                )
              }
              localStorage.setItem('standardUserId', data.userId)
              this.$message({
                message: '登录成功！',
                type: 'success',
                duration: 2000,
                offset: 150
              })
              //统一用户中心跳转
              ext && ext.access_token && this.bindJWT(ext.access_token)
              this.$router.push({ name: 'home' })
            } else {
              this.$message({
                message: msg,
                type: 'error',
                duration: 2000,
                offset: 150
              })
            }
          })
      } catch (err) {
        console.log(err)
        this.loading = false
        //验证码错误
        // if(err.resultCode===20011){
        //   this.getVerCode()
        // }
      }
    },
    reset() {
      this.$refs.form.resetFields()
    },
    bindJWT(access_token) {
      postJson(conf.bindJWTUrl + '/user/bind', { content: access_token })
        .then((res) => {
          console.log('jwt ok', res)
        })
        .catch((err) => {
          console.log('jwt err', err)
        })
    }
  },
  watch: {
    screenWidth: {
      //1519
      handler: function (val, oldVal) {
        // console.log("width val", val);
        let size = null
        if (val / 1519 < 0.8) {
          size = 0.8
        } else if (val / 1519 > 1.2) {
          size = 1.2
        } else {
          size = val / 1519
        }
        this.$nextTick(() => {
          this.$refs.information.style.transform = `translate(-50%, -50%) scale(${size})`
        })
      },
      immediate: true
    }
  }
}
</script>


<style lang="less" scoped>
.login {
  position: relative;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: url('../assets/image/login/bg.png');
  background-size: 100% 100%;
  background-color: @color;
  #information-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    box-sizing: border-box;
    width: 900px;
    height: 500px;
    border-radius: 30px;
    background: #fff;
    padding: 18px 25px;
    .el-row {
      height: 100%;
      .el-col {
        height: 100%;
        .ill-img {
          margin-top: 80px;
          margin-left: 10px;
          width: 400px;
        }
        .form-box {
          padding: 50px 20px;
          .tit1 {
            height: 26px;
            margin-bottom: 7px;
          }
          .tit2 {
            height: 48px;
          }
          .el-form {
            margin-top: 12px;
            /deep/ .el-input__prefix,
            .el-input__suffix {
              color: @color;
            }
            .loginBtn {
              margin-top: 20px;
              width: 100%;
              color: #fff;
            }
          }
          .save-pw {
            /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
              color: #000000;
              font-size: 13px;
            }
            /deep/ .el-checkbox__label {
              padding-left: 6px;
              font-size: 13px;
            }
            .fr {
              cursor: pointer;
              a {
                color: @color;
              }
            }
          }
          // 验证码
          .validate-container {
            position: relative;
            text-align: left;
            .validateImg {
              position: absolute;
              left: 200px;
              width: 106px;
              height: 39px;
              border-radius: 5px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
